import React, { useEffect, useRef } from "react";

const processData = [
  {
    number: "01",
    title: "Brief & Analyse",
    desc: "Compréhension des objectifs, définition du périmètre et cahier des charges.",
    side: "left",
  },
  {
    number: "02",
    title: "Design & Maquettage",
    desc: "Création de maquettes graphiques et validation itérative.",
    side: "right",
  },
  {
    number: "03",
    title: "Développement",
    desc: "Transformation des maquettes en code propre et tests multi-navigateurs.",
    side: "left",
  },
  {
    number: "04",
    title: "Mise en ligne & Suivi",
    desc: "Déploiement, formation et support post-lancement.",
    side: "right",
  },
];

const ProcessStep = ({ number, title, desc, side }) => {
  const stepRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry], observer) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (stepRef.current) observer.observe(stepRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={stepRef}
      className={`process-step process-step-${side}`}
    >
      <div className="process-step-content">
        <span className="process-step-number">{number}</span>

        <div className="process-step-info">
          <h3 className="process-step-title">{title}</h3>
          <p className="process-step-desc">{desc}</p>
        </div>
      </div>
    </div>
  );
};

const Process = () => {
  const headerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry], observer) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (headerRef.current) observer.observe(headerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
<section id="Process" className="process-section">
      <div className="process-wrapper">
        <div ref={headerRef} className="process-header">
          <h2 className="section-title">
            Un processus éprouvé pour votre réussite
          </h2>
          <p className="section-subtitle">
            De l'idée à la mise en ligne, je vous accompagne à chaque étape avec méthode et transparence.
          </p>
        </div>

        <div className="process-timeline">
          <div className="process-line" />
          {processData.map((p) => (
            <ProcessStep key={p.number} {...p} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
